// Generated by CoffeeScript 2.7.0
var Sticky;

Sticky = class Sticky {
  constructor(el1, params1) {
    this.el = el1;
    this.params = params1;
    this.init();
  }

  init() {
    this.scrollableContainer = DomMaster.getScrollableContainer(this.el);
    this.scrollableContainerTopSpacing = this.scrollableContainer.getBoundingClientRect().top;
    this.element = this.el.firstElementChild;
    this.topSpacing = this.element.getBoundingClientRect().bottom - this.scrollableContainerTopSpacing;
    this.el.style.height = `${this.element.getBoundingClientRect().height}px`;
    this.customStyle = this.params.style || {};
    if (this.params.stickyInContent) {
      this.stickyInContent = this.el.closest(`.${this.params.stickyInContent}`);
    }
    return this.bindEvents();
  }

  bindEvents() {
    this.__throttled__HandleScroll__func = _.throttle(this.handleScroll.bind(this), 300);
    return this.scrollableContainer.addEventListener('scroll', this.__throttled__HandleScroll__func, true);
  }

  sticky() {
    var ref;
    if (this._sticky) {
      return;
    }
    this.element.style.cssText += `position: fixed; top: ${this.scrollableContainerTopSpacing}px; left: 0; right: 0;`;
    if (!_.isBlank(this.customStyle)) {
      _.each(this.customStyle, (v, k) => {
        return this.element.style[k] = v;
      });
    }
    this.element.classList.add((ref = this.params) != null ? ref.className : void 0);
    return this._sticky = true;
  }

  reset() {
    var ref;
    if (!this._sticky) {
      return;
    }
    this.element.style.position = "initial";
    this.element.classList.remove((ref = this.params) != null ? ref.className : void 0);
    return this._sticky = false;
  }

  handleScroll(event) {
    if (this.topSpacing < event.target.scrollTop) {
      if (!this.stickyInContent || (this.stickyInContent && this.stickyInContent.getBoundingClientRect().bottom > this.scrollableContainerTopSpacing)) {
        return this.sticky();
      } else {
        return this.reset();
      }
    } else {
      return this.reset();
    }
  }

};

Vue.directive('sticky', {
  inserted: function(el, binding, vnode) {
    var disabled, params;
    if (binding.value.disabled) {
      return;
    }
    ({disabled, ...params} = binding.value);
    return setTimeout(function() { // 此处需要将同步代码处理成异步, 使指令在队列尾初始化
      return el.sticky = new Sticky(el, params);
    }, 0);
  },
  unbind: function(el, binding) {
    if (el.sticky) {
      el.sticky.scrollableContainer.removeEventListener('scroll', el.sticky.__throttled__HandleScroll__func, true);
      return delete el.sticky;
    }
  }
});
